// extracted by mini-css-extract-plugin
export var navBtn = "menu-module--nav-btn--2tTBB";
export var nav = "menu-module--nav--3oztN";
export var navExpanded = "menu-module--nav-expanded--10C4r";
export var navItem = "menu-module--nav-item--233vd";
export var navItemActive = "menu-module--nav-item-active--2G3DW";
export var navItemInner = "menu-module--nav-item-inner--35GrK";